export enum TypePlace {
    PMR= 'PMR',
    Paying = 'Payante',
    Free = 'Gratuite',
    Resident = 'Résident',
    Private = 'Privée',
    Rescue = 'Pompier',
    Delivering = 'Livraison'
}
